<!--SKU编辑  -->
<template>
	<el-dialog
		title="价格明细信息"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		width="600px">
		<div class="form-box">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="120px">
				<el-form-item label="SKU" prop="skuId">
					<el-select  v-model="dataForm.skuId" placeholder="请选择SKU" @change="computedPrice">
						<el-option
							v-for="item in skuList"
							:key="item.skuId"
							:label="item.skuName"
							:value="item.skuId">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="flex flex-between">
					<el-form-item label="现金价(元)" prop="cashPrice">
						<el-input v-model.trim="dataForm.cashPrice" maxlength="10" @input="computedCashPacketPrice"></el-input>
					</el-form-item>
					<el-form-item label="账期价(元)" prop="accperiodPrice">
						<el-input v-model.trim="dataForm.accperiodPrice" maxlength="10" @input="computedAccperiodPacketPrice"></el-input>
					</el-form-item>
				</div>
				<div class="flex flex-between">
					<el-form-item label="整包现金价(元)" prop="cashPacketPrice">
						<el-input v-model.trim="dataForm.cashPacketPrice" maxlength="9"></el-input>
					</el-form-item>
					<el-form-item label="整包账期价(元)" prop="accperiodPacketPrice">
						<el-input v-model.trim="dataForm.accperiodPacketPrice" maxlength="9"></el-input>
					</el-form-item>
				</div>
				<el-form-item label="备注" prop="remark">
					<el-input v-model.trim="dataForm.remark" type="textarea" :rows="2" maxlength="10"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button  size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button  size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				skuList: [],
				dataForm: {
					priceId: '',
					skuId: '',
					cashPrice: '',
					accperiodPrice: '',
					cashPacketPrice: '',
					accperiodPacketPrice: '',
					remark: ''
				},
				rules: {
					skuId: [
						{
							required: true,
							message: '请选择SKU',
							trigger: 'change'
						}
					],
					cashPrice: [
						{
							required: true,
							message: '请输入现金价',
							trigger: 'blur'
						},
						{
							pattern: /^(0|[1-9][0-9]*)(\.[0-9]{1,6})?$/,
							message: '请输入3位整数或者小数点前3位，后6位'
						}
					],
					accperiodPrice: [
						{
							required: true,
							message: '请输入账期价',
							trigger: 'blur'
						},
						{
							pattern: /^(0|[1-9][0-9]*)(\.[0-9]{1,6})?$/,
							message: '请输入3位整数或者小数点前3位，后6位'
						}
					],
					cashPacketPrice: [
						{
							required: true,
							message: '请输入整包现金价',
							trigger: 'blur'
						},
						{
							pattern: /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/,
							message: '请输入3位整数或者小数点前3位，后2位'
						}
					],
					accperiodPacketPrice: [
						{
							required: true,
							message: '请输入整包账期价',
							trigger: 'blur'
						},
						{
							pattern: /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/,
							message: '请输入3位整数或者小数点前3位，后2位'
						}
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(id,dt) {
				this.dialogVisible = true;
				this.getSkuList();
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					this.dataForm.priceId = id;
					delete this.dataForm.priceSkuId;
					if(dt) {
						this.dataForm.priceSkuId = dt.priceSkuId;
						this.dataForm.skuId = dt.skuId;
						this.dataForm.cashPrice = dt.cashPrice;
						this.dataForm.accperiodPrice = dt.accperiodPrice;
						this.dataForm.cashPacketPrice = dt.cashPacketPrice;
						this.dataForm.accperiodPacketPrice = dt.accperiodPacketPrice;
						this.dataForm.remark = dt.remark;
					}
				})
			},
			getSkuList() {
				let that = this;
				that.$request.post(
					"skuList",
					true, {
						userStatus: 0
					}
				)
				.then((res) => {
					if (res) {
						that.skuList = res.data
					}
				})
			},
			// 选择sku计算整包价
			computedPrice(val) {
				let sku = this.skuList.find(obj => obj.skuId == val);
				// 2.24*5=11.200000000000001解决办法
				const multiplier = 1000;
				// 整包现金价
				if(this.dataForm.cashPrice) {
					this.dataForm.cashPacketPrice = this.roundToTwo(sku.format * (this.dataForm.cashPrice * multiplier) / multiplier);
				}
				// 整包账期价
				if(this.dataForm.accperiodPrice) {
					this.dataForm.accperiodPacketPrice = this.roundToTwo(sku.format * (this.dataForm.accperiodPrice * multiplier) / multiplier);
				}
			},
			// 计算整包现金价
			computedCashPacketPrice() {
				if(this.dataForm.skuId) {
					let sku = this.skuList.find(obj => obj.skuId == this.dataForm.skuId);
					// 2.24*5=11.200000000000001解决办法
					const multiplier = 1000;
					this.dataForm.cashPacketPrice = this.roundToTwo(sku.format * (this.dataForm.cashPrice * multiplier) / multiplier);
				}
			},
			// 计算整包账期价
			computedAccperiodPacketPrice() {
				if(this.dataForm.skuId) {
					let sku = this.skuList.find(obj => obj.skuId == this.dataForm.skuId);
					// 2.24*5=11.200000000000001解决办法
					const multiplier = 1000;
					this.dataForm.accperiodPacketPrice = this.roundToTwo(sku.format * (this.dataForm.accperiodPrice * multiplier) / multiplier);
				}
			},
			// 四舍五入保留两位小数
			roundToTwo(num) {
				return Number(Math.round(num + 'e+2') + 'e-2');
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						let that = this;
						that.$request.post(
							that.dataForm.priceSkuId ? 'updatePriceSku' : 'addPricSku',
							true, that.dataForm
						)
						.then((res) => {
							that.dialogVisible = false;
							if (res) {
								that.$emit('getPriceSkuList');
								that.$message.success('保存成功');
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
.mb0 {
	margin-bottom: 0 !important;
}
.el-form-item{
	margin-bottom: 29px;
}
</style>
